import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

const projectionListItemSchema = z.object({
  url: z.string(),
  name: z.string(),
  code: z.string(),
  extent: z
    .object({
      west: z.number(),
      east: z.number(),
      north: z.number(),
      south: z.number(),
    })
    .nullable(),
});

export type ProjectionListItem = z.infer<typeof projectionListItemSchema>;

export const projectionListSchema = paginatedSchema(projectionListItemSchema);
export type ProjectionList = z.infer<typeof projectionListSchema>;

export const projectionSchema = projectionListItemSchema;
export type Projection = z.infer<typeof projectionSchema>;

export function useProjections(params = {}) {
  const url = combineUrlAndParams("/api/v4/projections/", params);
  return useParsedQuery<ProjectionList>(
    ["lizard-api-v4", "projections", url],
    () => fetchWithError(url),
    (json: unknown) => projectionListSchema.parse(json)
  );
}

export function useProjection(uuid: string) {
  return useParsedQuery<Projection>(
    ["lizard-api-v4", "projections", uuid],
    () => fetchWithError(`/api/v4/projections/${uuid}/`),
    (json: unknown) => projectionSchema.parse(json)
  );
}
